import { Injectable } from "@angular/core";

const GOOGLE_MAPS_API_KEY = "AIzaSyCDdolPd28awzHFXDs91gJjmrnE50On9YM";

export type Maps = typeof google.maps;

@Injectable()
export class GoogleMapService {
  public readonly api = this.load();

  // In GoogleMapService
  private load(): Promise<Maps> {
    console.log("Starting to load Google Maps script");
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    const callbackName = `GooglePlaces_cb_` + ((Math.random() * 1e9) >>> 0);
    script.src = this.getScriptSrc(callbackName);

    console.log("Script src:", script.src);

    interface MyWindow {
      [name: string]: (value: unknown) => void;
    }
    const myWindow: MyWindow = window as any;

    const promise = new Promise<Maps>((resolve, reject) => {
      myWindow[callbackName] = () => {
        console.log("Google Maps callback executed");
        if (window.google && window.google.maps) {
          console.log("Google Maps object available");
          resolve(google.maps);
        } else {
          reject(new Error("Google Maps failed to load"));
        }
      };
      script.onerror = (e) => {
        console.error("Script load error:", e);
        reject(new Error("Failed to load Google Maps script"));
      };
    });

    document.body.appendChild(script);
    return promise;
  }

  private getScriptSrc(callback: string): string {
    interface QueryParams {
      [key: string]: string;
    }
    const query: QueryParams = {
      v: "3",
      callback,
      key: GOOGLE_MAPS_API_KEY,
      libraries: "places",
    };
    const params = Object.keys(query)
      .map((key) => `${key}=${query[key]}`)
      .join("&");
    return `https://maps.googleapis.com/maps/api/js?${params}`; // Note the https:// here
  }
}
